import { Form, Input, Modal } from "antd";
import { useState } from "react";
import { noTrailingSpaceAllowedRule } from "../../../../utilities/generalUtility";

export const EditCommissionPlanModal = ({
  defaultValues,
  loading,
  modalVisible,
  setEditModalVisible,
  onFinish,
}) => {
  const [form] = Form.useForm();

  const [isDirty, setIsDirty] = useState(false);
  const values = { name: defaultValues.name };

  const onValuesChange = (v, newValues) => {
    setIsDirty(JSON.stringify(values) !== JSON.stringify(newValues));
  };

  return (
    <Modal
      width={568}
      centered
      className="s2-theme-style"
      open={modalVisible}
      okText="Update"
      onOk={() => form.submit()}
      title="Edit Commission Plan"
      okButtonProps={{ loading, disabled: !isDirty, name: "ok" }}
      onCancel={() => setEditModalVisible(false)}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        initialValues={values}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Name is required" },
            { min: 3, message: "Name must be at least 3 characters" },
            {
              max: 150,
              message: "Name cannot be longer than 150 characters",
            },
            noTrailingSpaceAllowedRule(),
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
